"use client"

import { createIcon } from "@chakra-ui/react"

export const CheckIcon = createIcon({
  defaultProps: {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
  },
  displayName: "CheckIcon",
  path: (
    <>
      <path d="M20 6 9 17l-5-5" />
    </>
  ),
  viewBox: "0 0 24 24",
})

export const ChevronDownCircleIcon = createIcon({
  defaultProps: {},
  displayName: "ChevronDownCircleIcon",
  path: (
    <>
      <path
        d="M256 64C150 64 64 150 64 256s86 192 192 192 192-86 192-192S362 64 256 64z"
        fill="none"
        strokeMiterlimit="10"
        strokeWidth="32"
      />
      <path
        d="m352 216-96 96-96-96"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="32"
      />
    </>
  ),
  viewBox: "0 0 512 512",
})

export const ChevronUpCircleIcon = createIcon({
  defaultProps: {},
  displayName: "ChevronUpCircleIcon",
  path: (
    <>
      <path
        d="m352 296-96-96-96 96"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="32"
      />
      <path
        d="M256 64C150 64 64 150 64 256s86 192 192 192 192-86 192-192S362 64 256 64z"
        fill="none"
        strokeMiterlimit="10"
        strokeWidth="32"
      />
    </>
  ),
  viewBox: "0 0 512 512",
})

export const CircleAlertIcon = createIcon({
  defaultProps: {
    fill: "none",
  },
  displayName: "CircleAlertIcon",
  path: (
    <>
      <path
        d="M12 14V6m0 12v-2m0-14C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </>
  ),
  viewBox: "0 0 24 24",
})

export const CloseIcon = createIcon({
  defaultProps: {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
  },
  displayName: "CloseIcon",
  path: (
    <>
      <path d="M18 6 6 18" />
      <path d="m6 6 12 12" />
    </>
  ),
  viewBox: "0 0 24 24",
})

export const CloseOutlineIcon = createIcon({
  defaultProps: {},
  displayName: "CloseOutlineIcon",
  path: (
    <>
      <path
        d="M368 368 144 144m224 0L144 368"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="32"
      />
    </>
  ),
  viewBox: "0 0 512 512",
})

export const EyeClosedIcon = createIcon({
  defaultProps: {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
  },
  displayName: "EyeClosedIcon",
  path: (
    <>
      <path d="M21 9c-2.4 2.667 -5.4 4 -9 4c-3.6 0 -6.6 -1.333 -9 -4" />
      <path d="M3 15l2.5 -3.8" />
      <path d="M21 14.976l-2.492 -3.776" />
      <path d="M9 17l.5 -4" />
      <path d="M15 17l-.5 -4" />
    </>
  ),
  viewBox: "0 0 24 24",
})

export const EyeIcon = createIcon({
  defaultProps: {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
  },
  displayName: "EyeIcon",
  path: (
    <>
      <path d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0" />
      <circle cx="12" cy="12" r="3" />
    </>
  ),
  viewBox: "0 0 24 24",
})

export const EyeOffIcon = createIcon({
  defaultProps: {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
  },
  displayName: "EyeOffIcon",
  path: (
    <>
      <path d="M10.733 5.076a10.744 10.744 0 0 1 11.205 6.575 1 1 0 0 1 0 .696 10.747 10.747 0 0 1-1.444 2.49" />
      <path d="M14.084 14.158a3 3 0 0 1-4.242-4.242" />
      <path d="M17.479 17.499a10.75 10.75 0 0 1-15.417-5.151 1 1 0 0 1 0-.696 10.75 10.75 0 0 1 4.446-5.143" />
      <path d="m2 2 20 20" />
    </>
  ),
  viewBox: "0 0 24 24",
})

export const FilterXIcon = createIcon({
  defaultProps: {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
  },
  displayName: "FilterXIcon",
  path: (
    <>
      <path
        d="M13.013 3H2l8 9.46V19l4 2v-8.54l.9-1.055"
        stroke="currentColor"
      />
      <path d="m22 3-5 5" stroke="currentColor" />
      <path d="m17 3 5 5" stroke="currentColor" />
    </>
  ),
  viewBox: "0 0 24 24",
})

export const InfoCircleIcon = createIcon({
  defaultProps: {
    "aria-hidden": "true",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
  },
  displayName: "InfoCircleIcon",
  path: (
    <>
      <path
        d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
  viewBox: "0 0 24 24",
})

export const InfoIcon = createIcon({
  defaultProps: {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
  },
  displayName: "InfoIcon",
  path: (
    <>
      <circle cx="12" cy="12" r="10" />
      <path d="M12 16v-4" />
      <path d="M12 8h.01" />
    </>
  ),
  viewBox: "0 0 24 24",
})

export const MinusIcon = createIcon({
  defaultProps: {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
  },
  displayName: "MinusIcon",
  path: (
    <>
      <path d="M5 12h14" />
    </>
  ),
  viewBox: "0 0 24 24",
})

export const AutoThemeIcon = createIcon({
  defaultProps: {
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: "0",
  },
  displayName: "AutoThemeIcon",
  path: (
    <path d="M12.707 2.793l2.208 2.207h3.085a1 1 0 0 1 .993 .883l.007 .117v3.085l2.207 2.208a1 1 0 0 1 .083 1.32l-.083 .094l-2.207 2.207v3.086a1 1 0 0 1 -.883 .993l-.117 .007h-3.086l-2.207 2.207a1 1 0 0 1 -1.32 .083l-.094 -.083l-2.208 -2.207h-3.085a1 1 0 0 1 -.993 -.883l-.007 -.117v-3.085l-2.207 -2.208a1 1 0 0 1 -.083 -1.32l.083 -.094l2.207 -2.209v-3.084a1 1 0 0 1 .883 -.993l.117 -.007h3.084l2.209 -2.207a1 1 0 0 1 1.414 0m-.707 5.207a3 3 0 0 0 -3 3v3.5a1 1 0 0 0 2 0v-.5h2v.5a1 1 0 0 0 .883 .993l.117 .007a1 1 0 0 0 1 -1v-3.5a3 3 0 0 0 -3 -3m0 2a1 1 0 0 1 1 1v1h-2v-1a1 1 0 0 1 .883 -.993z" />
  ),
  viewBox: "0 0 24 24",
})

export const MoonIcon = createIcon({
  defaultProps: {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
  },
  displayName: "MoonIcon",
  path: (
    <>
      <path d="M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z" />
    </>
  ),
  viewBox: "0 0 24 24",
})

export const PlusIcon = createIcon({
  defaultProps: {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
  },
  displayName: "PlusIcon",
  path: (
    <>
      <path d="M5 12h14" />
      <path d="M12 5v14" />
    </>
  ),
  viewBox: "0 0 24 24",
})

export const SortDescIcon = createIcon({
  defaultProps: {},
  displayName: "SortDescIcon",
  path: (
    <>
      <path
        d="M18.5 16.44V6.75a.75.75 0 0 0-1.5 0v9.69l-2.22-2.22a.75.75 0 1 0-1.06 1.06l3.5 3.5a.75.75 0 0 0 1.06 0l3.5-3.5a.75.75 0 1 0-1.06-1.06l-2.22 2.22ZM2 7.25a.75.75 0 0 1 .75-.75h9.5a.75.75 0 0 1 0 1.5h-9.5A.75.75 0 0 1 2 7.25Zm0 5a.75.75 0 0 1 .75-.75h5.5a.75.75 0 0 1 0 1.5h-5.5a.75.75 0 0 1-.75-.75Zm0 5a.75.75 0 0 1 .75-.75h3.5a.75.75 0 0 1 0 1.5h-3.5a.75.75 0 0 1-.75-.75Z"
        fill="currentColor"
      />
    </>
  ),
  viewBox: "0 0 24 24",
})

export const SunIcon = createIcon({
  defaultProps: {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
  },
  displayName: "SunIcon",
  path: (
    <>
      <circle cx="12" cy="12" r="4" />
      <path d="M12 2v2" />
      <path d="M12 20v2" />
      <path d="m4.93 4.93 1.41 1.41" />
      <path d="m17.66 17.66 1.41 1.41" />
      <path d="M2 12h2" />
      <path d="M20 12h2" />
      <path d="m6.34 17.66-1.41 1.41" />
      <path d="m19.07 4.93-1.41 1.41" />
    </>
  ),
  viewBox: "0 0 24 24",
})

export const TagIcon = createIcon({
  defaultProps: {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
  },
  displayName: "TagIcon",
  path: (
    <>
      <path d="M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z" />
      <circle cx="7.5" cy="7.5" fill="currentColor" r=".5" />
    </>
  ),
  viewBox: "0 0 24 24",
})

export const TagsIcon = createIcon({
  defaultProps: {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
  },
  displayName: "TagsIcon",
  path: (
    <>
      <path d="m15 5 6.3 6.3a2.4 2.4 0 0 1 0 3.4L17 19" />
      <path d="M9.586 5.586A2 2 0 0 0 8.172 5H3a1 1 0 0 0-1 1v5.172a2 2 0 0 0 .586 1.414L8.29 18.29a2.426 2.426 0 0 0 3.42 0l3.58-3.58a2.426 2.426 0 0 0 0-3.42z" />
      <circle cx="6.5" cy="9.5" fill="currentColor" r=".5" />
    </>
  ),
  viewBox: "0 0 24 24",
})
